// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import React from 'react'
import { type IntersticialProps } from './Intersticial'

const contactSalesURL: any = process.env.CONTACT_SALES_URL
const siteURL: any = process.env.CONSOLE_URL
const aiPerformanceDataUrl: any = process.env.AI_PERFORMANCE_DATA_URL

interface SiteIntersticials {
  bePartOfOurProgram: IntersticialProps
  getStarted: IntersticialProps
  deployToTheCloud: IntersticialProps
  betterRates: IntersticialProps
  premiumCustomerService: IntersticialProps
  performanceData: IntersticialProps
  availableModels: IntersticialProps
  enterpriseBenefits: IntersticialProps
}

const Intersticials: SiteIntersticials = {
  bePartOfOurProgram: {
    title: 'Be part of our startup program',
    subtitle:
      'Intel® Liftoff for Startups is an accelerator program empowering AI startups with Intel’s expertise, technology, and market reach.',
    actions: [{ label: 'Learn more', redirectTo: '/solutions/startups', variant: 'secondary', openInNewTab: false }],
    customClass: 'dark'
  },
  getStarted: {
    title: 'Get started today!',
    actions: [
      { label: 'Contact Sales', redirectTo: contactSalesURL, variant: 'outline-primary', openInNewTab: true },
      { label: 'Sign up', redirectTo: siteURL, variant: 'primary' }
    ],
    customClass: 'lightBlue'
  },
  deployToTheCloud: {
    customTitle: (
      <span className="h4 align-self-center text-center">
        Deploy to the cloud with options that suit your workload needs
      </span>
    ),
    customClass: 'text'
  },
  betterRates: {
    title: 'Looking for better rates?',
    subtitle: 'Enjoy committed use discounts  and explore alliances with model-as-a-service providers.',
    actions: [{ label: 'Get in touch', redirectTo: contactSalesURL, openInNewTab: true, variant: 'primary' }],
    customClass: 'lightBlue'
  },
  premiumCustomerService: {
    title: 'Intel’s premium customer service',
    subtitle:
      'Our dedicated support team is available 24/7 to assist you with any questions or issues. Benefit from our expertise and personalized support to ensure the success of your AI projects.',
    customClass: 'lightBlue'
  },
  performanceData: {
    customTitle: (
      <>
        <h2>
          <span className="h2 d-none d-sm-block text-white">Performance Data for Intel® AI Data Center Products</span>
          <span className="lead d-block d-sm-none text-white">
            Performance Data for Intel® AI Data Center Products
          </span>
        </h2>
        Find the latest AI benchmark performance data for our products.
      </>
    ),
    bottomAction: {
      label: 'Learn more',
      redirectTo: aiPerformanceDataUrl,
      openInNewTab: true,
      variant: 'link',
      customClass: 'secondary-link'
    },
    customClass: 'train-model'
  },
  availableModels: {
    customTitle: (
      <>
        <h2>
          <span className="h2 d-none d-sm-block text-white">Available models</span>
          <span className="lead d-block d-sm-none text-white">Available models</span>
        </h2>
        Learn which models can run in our products. See model performance data.
      </>
    ),
    bottomAction: {
      label: 'Learn more',
      redirectTo: aiPerformanceDataUrl,
      openInNewTab: true,
      variant: 'link',
      customClass: 'secondary-link'
    },
    customClass: 'available-models'
  },
  enterpriseBenefits: {
    title: 'Enterprise benefits',
    subtitle: 'Enjoy committed use discounts and explore alliances with model-as-a-service providers.',
    bottomAction: {
      label: 'Contact Sales',
      redirectTo: contactSalesURL,
      openInNewTab: true,
      variant: 'outline-primary'
    }
  }
}

export default Intersticials
